<div class="container">
  <div class="title">
    Créer {{ (hospitalNames.cyclesNameGenreMasculin ? 'un ' : 'une ') + hospitalNames.cyclesName.toLowerCase() }}
  </div>
  <div *ngIf="!isLoading; else loading" class="body">
    <div class="first-column">
      <div class="mg-b-12">
        <app-text-input
          [(inputModel)]="cycleName"
          ngDefaultControl
          [label]="
            'Nom ' + (hospitalNames.cyclesNameGenreMasculin ? 'du ' : 'de la ') + hospitalNames.cyclesName.toLowerCase()
          "
        ></app-text-input>
      </div>

      <mat-checkbox [(ngModel)]="isOptimUnderConstraint"
        >{{ hospitalNames.cyclesName }} d'optimisation sous contrainte</mat-checkbox
      >
      <mat-checkbox
        *ngIf="isOptimUnderConstraint && createMainOptim"
        class="mg-t-12"
        [(ngModel)]="isMainFromOptimUnderConstraint"
        >{{ hospitalNames.cyclesName }} principal d'optimisation sous contrainte</mat-checkbox
      >
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="cycle-duration default-select width-48" *ngIf="!isOptimUnderConstraint">
          <div class="select-label mg-t-12">
            Durée
            {{ (hospitalNames.cyclesNameGenreMasculin ? 'du ' : 'de la ') + hospitalNames.cyclesName.toLowerCase() }} en
            semaine
          </div>
          <div class="select-container">
            <select [(ngModel)]="cycleDuration" required>
              <option *ngFor="let duration of cycleDurations" [ngValue]="duration">{{ duration }}</option>
            </select>
          </div>
        </div>
        <div class="cycle-duration default-select width-48" *ngIf="isOptimUnderConstraint">
          <div class="select-label mg-t-12">
            {{
              isNight
                ? 'Besoins de nuit'
                : profileListNames.includes('Infirmières')
                  ? 'TVO associé'
                  : "Besoins d'anesthésie associé"
            }}
          </div>
          <div class="select-container">
            <select [(ngModel)]="cycleTVO" required>
              <option *ngFor="let cycleTVO of cyclesTVO" [ngValue]="cycleTVO">
                {{
                  isNight
                    ? cycleTVO.name
                    : cycleTVO.name +
                      '
              - ' +
                      cycleTVO.weeks +
                      ' semaines ' +
                      (cycleTVO.main && cycleTVO.main === true ? ' (Roulement principal)' : '')
                }}
              </option>
            </select>
          </div>
        </div>
        <div class="default-select width-48" *ngIf="!isOptimUnderConstraint">
          <div class="select-label mg-t-12">{{ hospitalNames.cyclesName }} source</div>
          <div class="select-container">
            <select [(ngModel)]="cycleSource" (ngModelChange)="updateProfiles()" required>
              <option *ngFor="let cycle of cycles" [ngValue]="cycle">{{ cycle.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="input-label mg-t-12">Type de soignant</div>

      <div class="profiles-options-container">
        <div *ngFor="let option of profileListOptions" fxLayoutAlign="space-between center" [style.gap]="gap">
          <button
            class="mat-flat-button"
            mat-flat-button
            (click)="getProfileListType(option)"
            [class.checked]="profileListNames.includes(option)"
            [disabled]="isOptionDisabled(option)"
          >
            {{ option }}
          </button>
        </div>
      </div>

      <!-- A utiliser avec l'ajout des personas -->
      <!-- <div *ngIf="profileListNames.includes('IBODE/IDE/AS')">
        <div class="input-label mg-t-12">Formations</div>

        <div class="profiles-options-container">
          <div *ngFor="let option of ['IDE', 'IBODE', 'AS']" fxLayoutAlign="space-between center" [style.gap]="gap">
            <button
              class="mat-flat-button"
              mat-flat-button
              (click)="getProfileListType(option)"
              [class.checked]="profileListNames.includes(option)"
              [disabled]="isOptionDisabled(option)"
            >
              {{ option }}
            </button>
          </div>
        </div>
      </div> -->

      <div *ngIf="isUsingSeniorities" class="mg-t-12">
        <div class="input-label">Séniorité</div>
        <div class="profiles-options-container">
          <div *ngFor="let option of profilesSeniorities" fxLayoutAlign="space-between center" [style.gap]="gap">
            <button
              class="mat-flat-button"
              mat-flat-button
              (click)="getProfileListType(option)"
              [class.checked]="selectedProfilesSeniorities.includes(option)"
            >
              {{ option }}
            </button>
          </div>
        </div>
      </div>

      <div class="input-label mg-t-12">Statut</div>
      <div class="profiles-options-container">
        <div *ngFor="let option of profilesStatus" fxLayoutAlign="space-between center" [style.gap]="gap">
          <button
            class="mat-flat-button"
            mat-flat-button
            (click)="getProfileListType(option)"
            [class.checked]="selectedProfilesStatus.includes(option)"
          >
            {{ option }}
          </button>
        </div>
      </div>

      <span *ngIf="isNight">Liste filtrée sur les profils autorisés à faire des gardes</span>
    </div>

    <div class="second-column">
      <div>
        <app-text-input
          class="search-input"
          label="Rechercher une personne"
          placeholder="Rechercher une personne ..."
          icon="search"
          iconType="mat-icon"
          [(inputModel)]="searchValue"
          ngDefaultControl
          (keyup)="doFilter($any($event.target).value)"
        ></app-text-input>
      </div>
      <div>
        <div class="profiles-box">
          <div *ngFor="let profile of profilesFormElements; let i = index" class="profile-box">
            <mat-checkbox
              [checked]="isProfileSelected(profile.value)"
              (change)="onProfileChange($event, profile.value)"
            >
              {{ profile.label }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-button (click)="close()" text="Annuler" btnType="text"></app-button>
    <app-button
      (click)="createCycle(generating)"
      [isSpinning]="isSpinning"
      [isSpinner]="true"
      [disabled]="isSpinning || !isFormValid() || getSelectedIDS(allProfiles ?? []).length === 0"
      btnType="primary"
      color="primary"
      [text]="
        'Créer ' + (hospitalNames.cyclesNameGenreMasculin ? 'le ' : 'la ') + hospitalNames.cyclesName.toLowerCase()
      "
    ></app-button>
  </div>
</div>

<ng-template #loading>
  <div class="spinnerContainer" fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template #generating>
  <div class="spinner-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <p>
      {{
        isError
          ? 'Une erreur est survenue'
          : progress > 99
            ? 'Mise à jour terminée'
            : progress < 20
              ? 'Début de la mise à jour...'
              : 'Mise à jour en cours...'
      }}
    </p>
    <mat-progress-bar class="myProgressBar" mode="determinate" [value]="progress"></mat-progress-bar>
    <span>{{ progress | mathRound }}%</span>
  </div>
</ng-template>
